import React from 'react';
// import styled from 'styled-components';

import Link from '#/components/basic/Link/Link';
import { useSelectorActiveChain } from '#/components/hooks';
import { getBlockExplorerAddressUrl } from '#/config/configUtils';

import ChainExplorerIcon from './ChainExplorerIcon';

type Props = {
  address: string;
};

export default function ChainExplorerLink({ address }: Props) {
  const { activeChain } = useSelectorActiveChain();
  return (
    <Link href={getBlockExplorerAddressUrl(address, activeChain)}>
      <ChainExplorerIcon />
    </Link>
  );
}
